import { render, staticRenderFns } from "./vFormPROJECT_SWITCH.vue?vue&type=template&id=3713acf0&scoped=true&"
import script from "./vFormPROJECT_SWITCH.vue?vue&type=script&lang=js&"
export * from "./vFormPROJECT_SWITCH.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3713acf0",
  null
  
)

export default component.exports